export const tackleErrorMessage = (dispatch, error) => {
  const errorData = error.response?.data.message || error.response?.data.detail || 'Sorry, an error occurred!';
  console.log('error.response: ', error.response);
  dispatch('assessments/showSnackBar', errorData, {root:true});
};